import { push } from 'connected-react-router'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import type { ItemInfos, PurchasableItem } from 'shared/store/ecommerce/order'
import {
    addProductToCart,
    fetchCartPriceEdges,
    handleMissingProducts,
    pointsPerEuroSelector,
    pointsSelector,
    priceSelector,
    removeProductFromCart,
    removePromotionFromCart,
    setCurrentItem,
    setCurrentItemInfos,
    subTotalSelector
} from 'shared/store/ecommerce/order'
import { fetchAvailableFeatures } from 'shared/store/features'
import type { ECommerceMetadata } from 'shared/store/metadata'
import { eCommerceMetadata, pageMetadata } from 'shared/store/metadata'
import type { RootState } from 'shared/store/reducers'
import type { MetaShortDTO } from 'shared/types'
import { catalogType, restaurantServices } from 'shared/utils'
import { CartSummaryComponent } from './CartSummaryComponent'

const mapStateToProps = (state: RootState) => {
    const { authenticated } = state.userState
    const navigationState = state.router.location.state
    const {
        products,
        restaurant,
        promotions,
        idsCouponsTemporaryBurned,
        minimumPrice,
        maximumPrice,
        loader
    } = state.ecommerceOrderState

    const sortedProducts = _.groupBy(products, 'categoryName')
    const pointsTotal = pointsSelector(state)
    const pointsPerEuroToUse = pointsPerEuroSelector(state)
    const priceOriginal = subTotalSelector(state)
    const { finalPrice } = priceSelector(state)
    const { operationsRepeat } = state.ecommerceCatalogState
    const cartHasPromotions =
        promotions.length > 0 ||
        products.find(
            e =>
                e.type !== catalogType.GAME &&
                e.promotions &&
                e.promotions.length > 0
        )
    return {
        restaurant,
        authenticated,
        pointsPerEuro: pointsPerEuroToUse,
        loader,
        hasKingdom:
            restaurant &&
            restaurant.services.includes(restaurantServices.KINGDOM),
        products,
        sortedProducts,
        priceOriginal,
        priceTotal: finalPrice,
        pointsTotal,
        operationsRepeat,
        cartHasPromotions,
        idsCouponsTemporaryBurned,
        promotions,
        minimumPrice,
        maximumPrice,
        error: navigationState && navigationState.error
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    addProductToCart: (product: PurchasableItem) =>
        d(addProductToCart(product)),
    handleMissingProducts: () => d(handleMissingProducts()),
    removeProductFromCart: (product: PurchasableItem) =>
        d(removeProductFromCart(product)),
    setCurrentItem: (product: PurchasableItem) => d(setCurrentItem(product)),
    setCurrentItemInfos: (itemInfos: ItemInfos) =>
        d(setCurrentItemInfos(itemInfos)),
    removePromotionFromCart: (couponCode: string) =>
        d(removePromotionFromCart(couponCode)),
    fetchAvailableFeatures: () => d(fetchAvailableFeatures()),
    pageMetadata: (payload: MetaShortDTO) => d(pageMetadata(payload)),
    sendECommerceMeta: (meta: ECommerceMetadata) => d(eCommerceMetadata(meta)),
    fetchCartPriceEdges: () => d(fetchCartPriceEdges()),
    navigate: (to: string) => d(push(to))
})

const CartSummary = connect(
    mapStateToProps,
    mapDispatchToProps
)(CartSummaryComponent)
export { CartSummary }
